export const GET_ALLOWANCE_CHECKING_REQUEST = "GET_ALLOWANCE_CHECKING_REQUEST";
export const GET_ALLOWANCE_CHECKING_SUCCESS = "GET_ALLOWANCE_CHECKING_SUCCESS";
export const GET_ALLOWANCE_CHECKING_FAIL = "GET_ALLOWANCE_CHECKING_FAIL";